import {
  DEFAULT_UI_DENSITY,
  normalizeUiDensity,
  type UiDensityPreference,
} from '../ports/uiDensityPreference';

export const UI_DENSITY_STORAGE_KEY = 'cpq:ui-density:v1';

export const browserUiDensityPreference: UiDensityPreference = {
  read() {
    try {
      const raw = window.localStorage.getItem(UI_DENSITY_STORAGE_KEY);
      if (raw === null || raw.trim() === '') return DEFAULT_UI_DENSITY;
      return normalizeUiDensity(Number(raw));
    } catch {
      return DEFAULT_UI_DENSITY;
    }
  },
  write(density) {
    try {
      window.localStorage.setItem(
        UI_DENSITY_STORAGE_KEY,
        String(normalizeUiDensity(density)),
      );
      return true;
    } catch {
      return false;
    }
  },
};
